import { ChangeEvent } from "react";

import { CloseIcon, SearchIcon } from "@/assets/icons";

import { twMerge } from "tailwind-merge";

const TEST_ID_PREFIX = "search-box";

type Props = {
  inputFieldName?: string;
  className?: string;
  placeHolder?: string;
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  testId?: string;
  onClear?: () => void;
};

const SearchBox = ({
  inputFieldName = "search-box",
  className,
  placeHolder = "Search",
  value,
  onChange,
  disabled,
  testId = TEST_ID_PREFIX,
  onClear
}: Props) => {
  return (
    <div
      className={twMerge(
        "flex items-center gap-1 border-[1px] border-gainsboro rounded-[12px] px-3 h-[40px]",
        disabled && "bg-white-smoke",
        className
      )}
    >
      <SearchIcon className="fill-light-gray w-[16px]" />
      <input
        name={inputFieldName}
        disabled={disabled}
        className="focus:outline-none w-full"
        placeholder={placeHolder}
        value={value}
        onChange={onChange}
        data-testid={`${testId}-search-input`}
      />
      {value && onClear && (
        <button aria-label="Clear selection" onClick={onClear}>
          <CloseIcon
            className={twMerge(
              "fill-dim-gray w-5 h-5",
              disabled && "fill-light-gray"
            )}
            aria-hidden="true"
            focusable="false"
          />
        </button>
      )}
    </div>
  );
};

export default SearchBox;
